import React from 'react';
// import JourneySlider from "../Package/JourneySlider"


function IframeComponent() {
  return (
    <>
      {/* Add the iframe here */}
      <iframe
        // src={JourneySlider}
        src="./socialLinks.html"
        width="100%"
        height="2000px"
        style={{ borderRadius: '0px', border: 'none' }}
        title="Embedded Content"
      />
      <style>
        {`
          @media (max-width: 991px) {
            iframe {
              height: 1300px; /* Set height for screens with a max width of 768px */
            }
          }
        `}
      </style>
    </>
  )
}

export default IframeComponent